/* tslint:disable */
/* eslint-disable */
/**
 * Donio
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProjectTimestamps } from './ProjectTimestamps';
import {
    ProjectTimestampsFromJSON,
    ProjectTimestampsFromJSONTyped,
    ProjectTimestampsToJSON,
    ProjectTimestampsToJSONTyped,
} from './ProjectTimestamps';
import type { ProjectDonationMatching } from './ProjectDonationMatching';
import {
    ProjectDonationMatchingFromJSON,
    ProjectDonationMatchingFromJSONTyped,
    ProjectDonationMatchingToJSON,
    ProjectDonationMatchingToJSONTyped,
} from './ProjectDonationMatching';
import type { Milestone } from './Milestone';
import {
    MilestoneFromJSON,
    MilestoneFromJSONTyped,
    MilestoneToJSON,
    MilestoneToJSONTyped,
} from './Milestone';
import type { ProjectContent } from './ProjectContent';
import {
    ProjectContentFromJSON,
    ProjectContentFromJSONTyped,
    ProjectContentToJSON,
    ProjectContentToJSONTyped,
} from './ProjectContent';
import type { ProjectState } from './ProjectState';
import {
    ProjectStateFromJSON,
    ProjectStateFromJSONTyped,
    ProjectStateToJSON,
    ProjectStateToJSONTyped,
} from './ProjectState';
import type { ProjectStatistics } from './ProjectStatistics';
import {
    ProjectStatisticsFromJSON,
    ProjectStatisticsFromJSONTyped,
    ProjectStatisticsToJSON,
    ProjectStatisticsToJSONTyped,
} from './ProjectStatistics';
import type { ProjectSettings } from './ProjectSettings';
import {
    ProjectSettingsFromJSON,
    ProjectSettingsFromJSONTyped,
    ProjectSettingsToJSON,
    ProjectSettingsToJSONTyped,
} from './ProjectSettings';

/**
 * 
 * @export
 * @interface Project
 */
export interface Project {
    /**
     * 
     * @type {string}
     * @memberof Project
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof Project
     */
    numericId: number;
    /**
     * 
     * @type {string}
     * @memberof Project
     */
    slug: string;
    /**
     * 
     * @type {ProjectContent}
     * @memberof Project
     */
    content: ProjectContent;
    /**
     * 
     * @type {ProjectSettings}
     * @memberof Project
     */
    settings: ProjectSettings;
    /**
     * 
     * @type {ProjectStatistics}
     * @memberof Project
     */
    statistics: ProjectStatistics;
    /**
     * 
     * @type {ProjectState}
     * @memberof Project
     */
    state: ProjectState;
    /**
     * 
     * @type {ProjectTimestamps}
     * @memberof Project
     */
    timestamps: ProjectTimestamps;
    /**
     * 
     * @type {Array<Milestone>}
     * @memberof Project
     */
    milestones: Array<Milestone>;
    /**
     * 
     * @type {string}
     * @memberof Project
     */
    organizationId: string | null;
    /**
     * 
     * @type {ProjectDonationMatching}
     * @memberof Project
     */
    donationMatching?: ProjectDonationMatching | null;
}

/**
 * Check if a given object implements the Project interface.
 */
export function instanceOfProject(value: object): value is Project {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('numericId' in value) || value['numericId'] === undefined) return false;
    if (!('slug' in value) || value['slug'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('settings' in value) || value['settings'] === undefined) return false;
    if (!('statistics' in value) || value['statistics'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('timestamps' in value) || value['timestamps'] === undefined) return false;
    if (!('milestones' in value) || value['milestones'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    return true;
}

export function ProjectFromJSON(json: any): Project {
    return ProjectFromJSONTyped(json, false);
}

export function ProjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): Project {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'numericId': json['numericId'],
        'slug': json['slug'],
        'content': ProjectContentFromJSON(json['content']),
        'settings': ProjectSettingsFromJSON(json['settings']),
        'statistics': ProjectStatisticsFromJSON(json['statistics']),
        'state': ProjectStateFromJSON(json['state']),
        'timestamps': ProjectTimestampsFromJSON(json['timestamps']),
        'milestones': ((json['milestones'] as Array<any>).map(MilestoneFromJSON)),
        'organizationId': json['organizationId'],
        'donationMatching': json['donationMatching'] == null ? undefined : ProjectDonationMatchingFromJSON(json['donationMatching']),
    };
}

export function ProjectToJSON(json: any): Project {
    return ProjectToJSONTyped(json, false);
}

export function ProjectToJSONTyped(value?: Project | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'numericId': value['numericId'],
        'slug': value['slug'],
        'content': ProjectContentToJSON(value['content']),
        'settings': ProjectSettingsToJSON(value['settings']),
        'statistics': ProjectStatisticsToJSON(value['statistics']),
        'state': ProjectStateToJSON(value['state']),
        'timestamps': ProjectTimestampsToJSON(value['timestamps']),
        'milestones': ((value['milestones'] as Array<any>).map(MilestoneToJSON)),
        'organizationId': value['organizationId'],
        'donationMatching': ProjectDonationMatchingToJSON(value['donationMatching']),
    };
}

